import React from 'react'
import './styles.scss'
import { config } from './config'

interface Props {
  name?: string
  text?: string | React.ReactNode
  sub?: string | React.ReactNode
  colors?: { main: string; sub: string; cover: string }
  img?:string
}

export const PersonIntroduction = ({
  name,
  sub,
  text,
  img,
  colors = { main: '#000', sub: '#aaa', cover: '#fff' }
}: Props) => (
  <div className='PersonIntroduction'>
    <div className='imagewrapper'>
      <img src={img} />
    </div>
    <div
      className='cover'
      style={{
        boxShadow: '0 0 0 .2em' + colors.cover,
        backgroundColor: colors.cover
      }}
    >
      {name && (
        <div className='name' style={{ color: colors.main }}>
          {name}
        </div>
      )}
      {sub && (
        <div className='sub' style={{ color: colors.sub }}>
          {sub}
        </div>
      )}
      {text && <div className='text'>{text}</div>}
    </div>
  </div>
)
